import { useState } from 'react';

import { useModals } from '@mantine/modals';

import { IconStar, IconStarFilled } from '@tabler/icons-react';

import { Button, Group, Stack, Text, Textarea } from '@optiro/ui';

import { useCreateRating } from '@/hooks/useCreateRating/useCreateRating';

type ENPSModalProps = {
  onSubmit: (values: { rating: number; comment?: string }) => void;
  initialRating?: number;
  initialComment?: string;
};

function ENPSModalContent({
  onSubmit,
  onCancel,
  initialRating = 0,
  initialComment = '',
}: ENPSModalProps & { onCancel: () => void }) {
  const [rating, setRating] = useState(initialRating);
  const [comment, setComment] = useState(initialComment);

  return (
    <Stack>
      <Text>Hvordan vil du vurdere Optiro?</Text>
      <Group justify="center" gap="xs">
        {[1, 2, 3, 4, 5].map((star) => (
          <Button key={star} variant="subtle" color="yellow" onClick={() => setRating(star)} px={0}>
            {star <= rating ? <IconStarFilled size={32} /> : <IconStar size={32} />}
          </Button>
        ))}
      </Group>
      <Textarea
        label="Kommentar (valgfri)"
        value={comment}
        onChange={(e) => setComment(e.currentTarget.value)}
        autosize
        minRows={2}
      />
      <Group justify="flex-end">
        <Button variant="default" onClick={onCancel}>
          Annuller
        </Button>
        <Button disabled={rating === 0} onClick={() => onSubmit({ rating, comment })}>
          Send
        </Button>
      </Group>
    </Stack>
  );
}

export function useENPSModal() {
  const modals = useModals();
  const createRating = useCreateRating();

  const handleSubmit = (values: { rating: number; comment?: string }) => {
    createRating.mutate({
      number: values.rating,
      comment: values.comment,
    });
    modals.closeModal('enps-modal');
  };

  function openENPSModal() {
    modals.openModal({
      modalId: 'enps-modal',
      title: 'eNPS Undersøgelse',
      size: 'sm',
      children: (
        <ENPSModalContent
          onSubmit={handleSubmit}
          onCancel={() => modals.closeModal('enps-modal')}
        />
      ),
    });
  }

  function closeENPSModal() {
    modals.closeModal('enps-modal');
  }

  return { openENPSModal, closeENPSModal };
}
